import gql from 'graphql-tag'
export default gql`query familiesQuery {
  families {
    name
    id
  }
}`